/* Matted – accessibilité (WCAG 2.1 AA) – oct. 2026
   Correctifs appliqués après chargement, pour les éléments générés par des blocs
   personnalisés, des applications ou du JavaScript. */
(function () {
  'use strict';

  function fix(root) {
    root = root || document;

    // Bouton « retour » des fiches produit (mobile) : icône seule, sans nom
    root.querySelectorAll('.mtd-back-mobile:not([aria-label])').forEach(function (b) {
      b.setAttribute('aria-label', 'Retour à la page précédente');
    });

    // Configurateur : étapes présentées comme des onglets sans en être
    root.querySelectorAll('ol.mc-steps[role="tablist"]').forEach(function (ol) {
      ol.removeAttribute('role');
      ol.setAttribute('aria-label', 'Étapes du configurateur');
    });

    // Calculateur de quantités : titre h4 placé juste sous le titre de la page
    root.querySelectorAll('h4.calculator-title:not([aria-level])').forEach(function (h) {
      h.setAttribute('aria-level', '2');
    });

    // Appli de CGV : la case du panier latéral reprenait l'identifiant de celle de la page panier
    root.querySelectorAll('#CartDrawer .rterms-checkbox').forEach(function (c, i) {
      var id = 'rterms-drawer-' + (i + 1);
      if (c.id === id) return;
      var lab = c.parentElement && c.parentElement.querySelector('label[for="' + c.id + '"]');
      c.id = id;
      if (lab) lab.setAttribute('for', id);
    });

    scrollables(root);
  }

  // Zones qui défilent horizontalement : atteignables au clavier quand elles débordent
  var SCROLL_SEL = '.mqr__list, .mc-promo__inner, .mh-tabs__nav';
  function scrollables(root) {
    (root || document).querySelectorAll(SCROLL_SEL).forEach(function (el) {
      var over = el.scrollWidth > el.clientWidth + 2;
      if (over && !el.hasAttribute('tabindex')) {
        el.setAttribute('tabindex', '0');
        el.setAttribute('data-mq-scroll', '');
      } else if (!over && el.hasAttribute('data-mq-scroll')) {
        el.removeAttribute('tabindex');
        el.removeAttribute('data-mq-scroll');
      }
    });
  }

  // Page panier : la commande est bloquée tant que la case CGV n'est pas cochée ; on le dit
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#checkout');
    if (!btn) return;
    var box = btn.parentElement && btn.parentElement.querySelector('.rterms-checkbox');
    if (!box || box.checked) return;
    var msg = document.getElementById('MqCartTermsMsg');
    if (!msg) {
      msg = document.createElement('p');
      msg.id = 'MqCartTermsMsg';
      msg.className = 'mq-cart-terms-msg';
      msg.setAttribute('role', 'alert');
      msg.textContent = 'Veuillez cocher la case pour accepter les conditions générales de vente avant de commander.';
      box.parentElement.insertAdjacentElement('afterend', msg);
      box.setAttribute('aria-describedby', 'MqCartTermsMsg');
    }
    msg.hidden = false;
    box.focus();
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('rterms-checkbox') && e.target.checked) {
      var msg = document.getElementById('MqCartTermsMsg');
      if (msg) msg.hidden = true;
    }
  });

  var t;
  function later() { clearTimeout(t); t = setTimeout(function () { fix(document); }, 150); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { fix(document); });
  else fix(document);
  window.addEventListener('load', later);
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { scrollables(document); }, 200); });
  new MutationObserver(later).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Produits livrés gratuitement (tag « livraison-offerte ») : on adapte le bandeau livraison de la fiche,
   rédigé pour la règle générale (29,90 € / offerte dès 500 €). */
(function () {
  'use strict';
  if (!/\/products\/[^/]+/.test(location.pathname)) return;
  var url = location.pathname.replace(/\/$/, '') + '.js';
  fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
    if (!p || !p.tags || p.tags.indexOf('livraison-offerte') === -1) return;
    var rules = [
      [/29,90\s*€\s*\/\s*Offerte dès 500\s*€/g, 'offerte'],
      [/Livraison offerte dès 500\s*€\s*d[’']achat/g, 'Livraison offerte']
    ];
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walker.nextNode())) {
      var v = n.nodeValue, w = v;
      rules.forEach(function (r) { w = w.replace(r[0], r[1]); });
      if (w !== v) n.nodeValue = w;
    }
  }).catch(function () {});
})();

/* Menu mobile ouvert : la page dessous ne doit plus défiler au doigt.
   Safari iOS ignore le blocage par overflow:hidden ; on bloque donc le geste
   sauf quand il fait défiler le contenu du menu lui-même. */
(function () {
  'use strict';
  var SCROLLERS = '.menu-drawer__inner-submenu, .menu-drawer__navigation-container';
  function drawerOpen() {
    var d = document.getElementById('Details-menu-drawer-container');
    return !!(d && d.hasAttribute('open'));
  }
  var startY = 0;
  document.addEventListener('touchstart', function (e) {
    if (e.touches && e.touches.length === 1) startY = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!drawerOpen() || !e.touches || e.touches.length !== 1) return;
    var drawer = document.getElementById('menu-drawer');
    var sc = e.target && e.target.closest ? e.target.closest(SCROLLERS) : null;
    if (!sc || !drawer || !drawer.contains(sc)) { if (e.cancelable) e.preventDefault(); return; }
    var dy = e.touches[0].clientY - startY;
    var atTop = sc.scrollTop <= 0;
    var atBottom = sc.scrollTop + sc.clientHeight >= sc.scrollHeight - 1;
    if (sc.scrollHeight <= sc.clientHeight + 1 || (dy > 0 && atTop) || (dy < 0 && atBottom)) {
      if (e.cancelable) e.preventDefault();
    }
  }, { passive: false });
})();

/* Vidéos (fiches produits, page Vidéos, articles) : sur mobile, toucher une vidéo pour la lancer
   ne doit pas faire remonter la page (lecture, sortie du plein écran, redimensionnement de la barre
   d'adresse). On mémorise la position au toucher et on la rétablit si la page saute toute seule. */
(function () {
  'use strict';
  var g = null;
  function arm(v) { g = { y: window.scrollY, v: v, until: Date.now() + 3000, moved: false }; }
  function isVideo(t) { return t && (t.tagName === 'VIDEO' || (t.closest && t.closest('video, .mqf-video, .mvid-player, .media-video'))); }
  ['touchstart', 'pointerdown'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var t = e.target;
      if (isVideo(t)) arm(t.tagName === 'VIDEO' ? t : (t.querySelector && t.querySelector('video')) || t);
    }, { capture: true, passive: true });
  });
  ['touchmove', 'wheel', 'keydown'].forEach(function (ev) { document.addEventListener(ev, function () { if (g) g.moved = true; }, { passive: true }); });
  function restore() {
    if (!g || g.moved || Date.now() > g.until) return;
    if (Math.abs(window.scrollY - g.y) > 120) window.scrollTo(0, g.y);
  }
  window.addEventListener('scroll', function () { if (g && !g.moved && Date.now() <= g.until) requestAnimationFrame(restore); }, { passive: true });
  ['play', 'playing', 'pause', 'webkitbeginfullscreen', 'webkitendfullscreen', 'loadedmetadata'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (!g || e.target !== g.v) return;
      if (ev === 'webkitendfullscreen') g.until = Date.now() + 1500;
      setTimeout(restore, 50); setTimeout(restore, 400);
    }, true);
  });
  document.addEventListener('fullscreenchange', function () {
    if (!document.fullscreenElement && g) { g.until = Date.now() + 1500; setTimeout(restore, 50); setTimeout(restore, 400); }
  });
})();
